"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var getDifferenceOf = function getDifferenceOf(date1, date2, unit) {
  var a = (0, _momentTimezone["default"])(date1);
  var b = (0, _momentTimezone["default"])(date2);
  return b.diff(a, unit);
};

var _default = {
  add: function add() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).add(amount, units);
  },
  addFormat: function addFormat() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var output = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'LL';
    var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).add(amount, units).format(output);
  },
  ago: function ago() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date || new Date()).fromNow();
  },
  subtract: function subtract() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).subtract(amount, units);
  },
  subtractFormat: function subtractFormat() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var output = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'LL';
    var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).subtract(amount, units).format(output);
  },
  utcOffset: function utcOffset() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).utcOffset(offset);
  },
  utcOffsetFormat: function utcOffsetFormat() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LL';
    var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).utcOffset(offset).format(output);
  },
  utcTimezone: function utcTimezone() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Europe/Madrid';
    return _momentTimezone["default"].tz(date, timezone);
  },
  verbose: function verbose() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LL';
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'es';

    _momentTimezone["default"].locale(locale);

    return (0, _momentTimezone["default"])(date).format(output);
  },
  isAfterNow: function isAfterNow(date, timezone) {
    return (0, _momentTimezone["default"])().tz(timezone).isBefore(date);
  },
  startOfDay: function startOfDay(date) {
    return (0, _momentTimezone["default"])(date).startOf('day');
  },
  today: function today() {
    return (0, _momentTimezone["default"])().utc().hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
  },
  yesterday: function yesterday() {
    return (0, _momentTimezone["default"])().utc().subtract(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
  },
  tomorrow: function tomorrow() {
    return (0, _momentTimezone["default"])().utc().add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
  },
  currentWeek: function currentWeek() {
    return {
      start: (0, _momentTimezone["default"])().utc().startOf('isoWeek').toISOString(),
      end: (0, _momentTimezone["default"])().utc().endOf('isoWeek').toISOString()
    };
  },
  currentMonth: function currentMonth() {
    return {
      start: (0, _momentTimezone["default"])().utc().startOf('month').toISOString(),
      end: (0, _momentTimezone["default"])().utc().endOf('month').toISOString()
    };
  },
  timezoneVerbose: function timezoneVerbose() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Europe/Madrid';
    var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LL';
    var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'es';

    _momentTimezone["default"].locale(locale);

    return _momentTimezone["default"].tz(date, timezone).format(output);
  },
  isDifferentDay: function isDifferentDay(date1, date2) {
    return (0, _momentTimezone["default"])(date1).format('MD') !== (0, _momentTimezone["default"])(date2).format('MD');
  },
  before: function before(date1, date2) {
    return (0, _momentTimezone["default"])(date1).isBefore(date2);
  },
  getDifferenceOf: getDifferenceOf,
  getDifferenceOfDays: function getDifferenceOfDays(date1, date2) {
    var a = (0, _momentTimezone["default"])((0, _momentTimezone["default"])(date1).format('YYYY-MM-DD'));
    var b = (0, _momentTimezone["default"])((0, _momentTimezone["default"])(date2).format('YYYY-MM-DD'));
    return b.diff(a, 'days');
  },
  moment: _momentTimezone["default"]
};
exports["default"] = _default;